import {
  SUBSCRIPTION_TRIAL,
  SUBSCRIPTION_CREATOR,
  SUBSCRIPTION_BUSINESS,
  SUBSCRIPTION_ENTERPRISE,
} from '../config';

export const CHECK_VALUE = 'check';
export const CROSS_VALUE = 'cross';

export const subscriptionPlans = [
  {
    id: SUBSCRIPTION_TRIAL,
    header: 'Sign up today and create your first video microlesson for free',
    title: 'Trial',
    pricePerMonth: 'Free',
    pricePerYear: 'Free',
    amountOfUsers: 'Supports up to 9 learners with tapybl LMS',
    storage: '5 GB Storage',
    aiCreditsPerMonth: '500,000 AI credits',
    aiCreditsPerYear: '500,000 AI credits',
    features: [
      '7 days of full access to the platform',
      'LTI 1.3 interoperability (for LMS integration)',
      'SCORM 1.2 support (for export to LMS)',
      'AI-powered video microlesson generator',
      'AI assistant builder',
      'Complete access to Storyblocks with over 4 million assets',
      'Slide-to-video lesson generation',
      'Prompt-to-video lesson generation',
      'Supplemental learning paths',
      'Built-in LMS with learner tracking (up to 9 learners)',
      'Course analytics',
      'Dynamic challenge branching',
    ],
    buttonText: 'Start your 7-day free trial',
    usersPerMonth: true,
    trialTier: SUBSCRIPTION_TRIAL,
    trialText: 'Start 7-day trial',
  },
  {
    id: SUBSCRIPTION_CREATOR,
    header:
      'For individuals and small teams wanting to create bite-sized learning experiences',
    title: 'Creator',
    pricePerMonth: '€ 29',
    pricePerYear: '€ 340',
    amountOfUsers: 'Supports up to 9 learners with tapybl LMS',
    storage: '5 GB Storage',
    aiCreditsPerMonth: '1,000,000 Al credits / month',
    aiCreditsPerYear: '12,000,000 Al credits / year',
    features: [
      'AI-powered video microlesson generator',
      'AI assistant builder',
      'Complete access to Storyblocks with over 4 million assets',
      'Slide-to-video lesson generation',
      'Prompt-to-video lesson generation',
      'Supplemental learning paths',
      'Built-in LMS with learner tracking (up to 9 learners)',
      'Course analytics',
      'Dynamic challenge branching',
      'Includes 1 Creator license (limit 1 per workspace)',
      'Workspace customization',
      'Free to cancel anytime',
    ],
    buttonText: 'Sign up',
    usersPerMonth: true,
    trialTier: SUBSCRIPTION_TRIAL,
    trialText: 'Start 7-day trial',
  },
  {
    id: SUBSCRIPTION_BUSINESS,
    header:
      'For growing teams wanting to create and manage bite-sized learning at scale',
    title: 'Business',
    pricePerMonth: '€ 125',
    pricePerYear: '€ 1,500',
    amountOfUsers: 'Supports up to 49 learners with tapybl LMS',
    storage: '50 GB Storage',
    aiCreditsPerMonth: '2,000,000 Al credits / month',
    aiCreditsPerYear: '24,000,000 Al credits / year',
    features: [
      'AI-powered video microlesson generator',
      'AI assistant builder',
      'Complete access to Storyblocks with over 4 million assets',
      'Slide-to-video lesson generation',
      'Prompt-to-video lesson generation',
      'Supplemental learning paths',
      'Built-in LMS with learner tracking (up to 49 learners)',
      'Course analytics',
      'Advanced interactive features',
      'Dynamic challenge branching',
      'Includes 1 Creator license (add more anytime)',
      'Workspace customization',
      'Free to cancel anytime',
    ],
    buttonText: 'Sign up',
    usersPerMonth: true,
    trialTier: SUBSCRIPTION_TRIAL,
    trialText: 'Start 7-day trial',
  },
  {
    header: 'Unlimited flexibility for enterprise learning teams',
    title: 'Enterprise',
    pricePerMonth: 'On request',
    pricePerYear: 'On request',
    amountOfUsers: 'Supports unlimited learners with tapybl LMS',
    storage: 'Unlimited storage',
    aiCreditsPerMonth: 'Unlimited Al credits',
    aiCreditsPerYear: 'Unlimited Al credits',
    features: [
      'LTI 1.3 interoperability (LMS integration)',
      'SCORM 1.2 support (LMS export)',
      'AI-powered video microlesson generator',
      'AI assistant builder',
      'Complete access to Storyblocks with over 4 million assets',
      'Slide-to-video lesson generation',
      'Prompt-to-video lesson generation',
      'Supplemental learning paths',
      'Built-in LMS with learner tracking',
      'Course analytics',
      'Dynamic challenge branching',
      'Unlimited creator licenses',
      'Personalized onboarding & priority support',
      'Custom data storage & integrations',
      'White label / full customization',
      'Free to cancel anytime',
    ],
    buttonText: 'Request quote',
    usersPerMonth: false,
    trialText: 'Book demo',
  },
];

export const FeaturesTableConf = {
  subheader: [
    'Full list of features',
    'Trial',
    'Creator',
    'Business',
    'Enterprise',
  ],
  buttons: [
    undefined,
    SUBSCRIPTION_TRIAL,
    SUBSCRIPTION_CREATOR,
    SUBSCRIPTION_BUSINESS,
    SUBSCRIPTION_ENTERPRISE,
  ],
  sections: [
    {
      title: 'Content creation & AI power',
      data: [
        [
          'AI video microlesson builder',
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
        ],
        [
          'AI assistant builder',
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
        ],
        [
          'AI video generation',
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
        ],
        [
          'Instant content converter (pdf/pptx/doc)',
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
        ],
        [
          'Auto translation',
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
        ],
        [
          'Workflow lesson builder',
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
        ],
        [
          'Base AI credits / month',
          '500,000',
          '1,000,000',
          '2,000,000',
          'Unlimited',
        ],
        [
          'Option to add AI credits',
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
        ],
        ['Maximum resolution supported', 'HD', 'HD', 'HD', 'UHD'],
      ],
    },
    {
      title: 'Learning experience design',
      data: [
        [
          'Choice branching',
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
        ],
        [
          'Supplemental learning paths',
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
        ],
        [
          'Quiz capabilities',
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
        ],
        [
          'Multiple choice questions',
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
        ],
        [
          'Branching scenarios',
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
        ],
        [
          'Challenge branching',
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
        ],
        ['Jump-to nodes', CHECK_VALUE, CHECK_VALUE, CHECK_VALUE, CHECK_VALUE],
      ],
    },
    {
      title: 'Media & resources',
      data: [
        [
          'Storyblock library',
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
        ],
        ['Video uploads', 'Unlimited', 'Unlimited', 'Unlimited', 'Unlimited'],
        ['Audio uploads', 'Unlimited', 'Unlimited', 'Unlimited', 'Unlimited'],
        [
          'Content integration (Vimeo)',
          CHECK_VALUE,
          CROSS_VALUE,
          CROSS_VALUE,
          CHECK_VALUE,
        ],
        ['Data storage included', '5GB', '5GB', '50GB', 'Unlimited'],
        [
          'Option to purchase additional storage',
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
        ],
      ],
    },
    {
      title: 'Sharing & distribution',
      data: [
        ['Shareable courses', '5', 'Unlimited', 'Unlimited', 'Unlimited'],
        [
          'SCORM runtime compatible',
          CHECK_VALUE,
          CROSS_VALUE,
          CROSS_VALUE,
          CHECK_VALUE,
        ],
        [
          'SCORM full (including player)',
          '*',
          CROSS_VALUE,
          CROSS_VALUE,
          CHECK_VALUE,
        ],
        ['LTI support', CHECK_VALUE, CROSS_VALUE, CROSS_VALUE, CHECK_VALUE],
      ],
    },
    {
      title: 'Content management & scale',
      data: [
        ['Course analytics', 'Advanced', 'Advanced', 'Advanced', 'Full suite'],
        ['PDF export', CHECK_VALUE, CHECK_VALUE, CHECK_VALUE, CHECK_VALUE],
        [
          'Learner management',
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
        ],
      ],
    },
    {
      title: 'Branding & customization',
      data: [
        [
          'Brand customization',
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
        ],
      ],
    },
    {
      title: 'Account resources & limits',
      data: [
        ['Total course authors', '1', '1', '1', 'Unlimited'],
        [
          'Ability to add more course authors',
          CROSS_VALUE,
          CROSS_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
        ],
        ['Total admin roles', '1', '1', 'Unlimited', 'Unlimited'],
        ['Maximum users allowed', '10', '10', '50', 'Unlimited'],
        [
          'Managed help desk',
          CROSS_VALUE,
          CROSS_VALUE,
          CHECK_VALUE,
          CHECK_VALUE,
        ],
        [
          'Account & onboarding support',
          CROSS_VALUE,
          CROSS_VALUE,
          CROSS_VALUE,
          CHECK_VALUE,
        ],
      ],
    },
    // {
    //   title: 'Support',
    //   data: [
    //     [
    //       'Managed help desk',
    //       CROSS_VALUE,
    //       CROSS_VALUE,
    //       CHECK_VALUE,
    //       CHECK_VALUE,
    //     ],
    //     [
    //       'Account & onboarding support',
    //       CROSS_VALUE,
    //       CROSS_VALUE,
    //       CROSS_VALUE,
    //       CHECK_VALUE,
    //     ],
    //   ],
    // },
  ],
};

export const FAQ = [
  {
    question: 'Can I try tapybl before buying it?',
    answer: [
      'Yes, tapybl offers a 7-day trial option which gives you full access to all of our advanced features, including LTI 1.3 compatibility.',
    ],
  },
  {
    question: 'Do you offer monthly payment plans?',
    answer: [
      'Yes, you can choose between monthly or annual subscription options.',
    ],
  },
  {
    question: 'What is a User?',
    answer: [
      'In tapybl, a "User" is anyone with access to the platform and can be assigned specific roles within a workspace. Users may be learners or instructors, with tailored permissions based on their role. Learners engage with training programs and courses, while instructors deliver and facilitate these programs. User roles and permissions are managed by those with Admin rights within the workspace.',
    ],
  },
  {
    question: 'What is a Creator?',
    answer: [
      'A "Creator" is a special role in tapybl with permissions to build and manage content. Creators have a dedicated creator license, which includes access to the full course creation suite and other advanced tools. For the Creator package, only one Creator license is available per workspace. However, in Business and Enterprise plans, you can purchase additional Creator licenses as needed. Creators can build courses, adding both learners and instructors to enhance the learning experience.',
    ],
  },
  {
    question: 'What are AI credits?',
    answer: [
      'AI Credits allow you to harness the power of tapybl AI. These credits are used when you utilize AI-powered features, such as generating assessments, transforming content into videos, and creating interactive video lessons. AI credits give you access to the advanced capabilities of our AI assistant, helping streamline your course creation and improve efficiency.',
    ],
  },
  {
    question: 'How many AI credits do I need?',
    answer: [
      'The number of AI Credits needed varies based on the specific content and actions performed, but here are some rough averages to help you estimate:',
      '-	Generating assessments: Typically uses between 1,000 – 5,000 credits on average, depending on the size of the source material.',
      '-	Generating images: AI Image generation uses between 15,000 – 25,000 credits per image, depending on the topic at hand.',
      '-	Transforming content (e.g., PDFs, PowerPoints): Typically uses between 1,000-1,500 credits per slide, though it may be higher based on the size and nature of the content.',
      '-	Creating lessons: Generally, creating lessons uses between 2,000 – 10,000 credits, but this can vary with the depth and the source material involved.',
      "AI Credits are calculated and deducted after each action, so you're only charged for the specific AI-powered tasks you perform.",
    ],
  },
];
